import { Injectable, Injector } from '@angular/core';
import { DataService } from './data.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Store } from '@ngrx/store';

@Injectable()
export class CountryService extends DataService {
  constructor(private http: HttpClient, protected injector: Injector, protected store: Store<any>) {
    super(injector, store);
  }

  getcountriesAndTimezone() {
    return this.http.get(`${environment.apiUrl}/public/v1/countries`);
  }

  getOperationZone(countryId:string) {
    return this.http.get(`${environment.apiUrl}/public/v1/operation-zone/?countryId=${countryId}&all=true`);
  }

  getRegions() {
    return this.http.get(`${environment.apiUrl}/super/v1/regions/get-regions`);
  }

  getSectors() {
    return this.http.get(`${environment.apiUrl}/super/v1/sectors/get-sectors`);
  }

  fetchCountries() {
    return this.http
      .get(`${environment.apiUrl}/country`)
      .toPromise()
      .then((res) => {
        return res || [];
      })
      .catch((err) => {
        console.log(err);
        return Promise.reject(err);
      });
  }
}
